import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sf_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem("sf_token")) {
      localStorage.removeItem("sf_token");
      localStorage.removeItem("sf_user");
      if (!window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/customer")) {
        // leave as is
      } else {
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e) {
  const d = e?.response?.data?.detail ?? e?.message;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).filter(Boolean).join(", ");
  if (typeof d === "string") return d;
  return "Something went wrong. Please try again.";
}

export default api;
